import { useRef } from 'react';
import Picker1 from '../../../../../../core/components/pickers/Picker1';
import { CustomDivider } from '../../../../../../core/components/pickers/types';
import { MdOutlineFilterAlt } from 'react-icons/md';
import {
  CellRangeValidation,
  DateFilterCondition,
  IconSetsValidation,
  ListValidation,
  NumberFilterCondition,
  NumberValidation,
  TextFilterCondition,
  ValidationCriteria,
  ValidationFilterCondition,
  ValidationRule,
} from '../../../../../../sheet/types';
import ValueCheckbox from '../../../../../../sheet/components/grid/filterDropdown/filterAtoms/ValueCheckbox';
import { UpdateRule } from '../useCreateDataValidation';

// #region filter condition picker
interface FilterConditionPickerProps {
  criteria: ValidationCriteria;
  rule: ValidationRule;
  updateRule: UpdateRule;
}
const FilterConditionPicker = ({
  criteria,
  rule,
  updateRule,
}: FilterConditionPickerProps) => {
  const conditionOptions = getFilterConditionOptions(criteria);
  const selectedRef = useRef<HTMLButtonElement | null>(null);

  const changeCondition = (condition: ValidationFilterCondition) => {
    updateRule({ condition });
  };
  const toggleShowList = (showList: boolean) => {
    updateRule({ showList });
  };

  // #region views
  const showListCheckbox = (
    rule: CellRangeValidation | ListValidation | IconSetsValidation
  ) => {
    const isSelected = !!rule.showList;
    return (
      <ValueCheckbox
        style={{ height: '32px', fontSize: '13px' }}
        visibleValue="Show List"
        isSelected={isSelected}
        onSelect={(_, _1, val) => toggleShowList(val)}
      />
    );
  };

  const renderOtherCondition = () => {
    switch (rule.criteria) {
      case ValidationCriteria.CellRange:
      case ValidationCriteria.List:
      case ValidationCriteria.IconSets:
        return showListCheckbox(rule);
      // case ValidationCriteria.IconSets:
      //   return showIconSetCategories(rule);
    }
    return null;
  };

  if (!conditionOptions?.length) {
    return renderOtherCondition();
  }
  // #endregion

  const condition = (rule as NumberValidation).condition;

  const menu = () => (
    <Picker1.Menu ref={selectedRef}>
      <Picker1.MenuButton Icon={<MdOutlineFilterAlt />} title={condition} />
      <Picker1.MenuList<ValidationFilterCondition>
        selectedRef={selectedRef}
        selectedValue={condition}
        options={conditionOptions}
        changeValue={changeCondition}
      />
    </Picker1.Menu>
  );

  return menu();
};

export default FilterConditionPicker;

// #endregion

// #region helpers
const getFilterConditionOptions = (
  criteria: ValidationCriteria
): Array<ValidationFilterCondition | CustomDivider> | undefined => {
  switch (criteria) {
    case ValidationCriteria.Number:
    case ValidationCriteria.TextLength:
      return Object.values(NumberFilterCondition);
    case ValidationCriteria.Date:
      return Object.values(DateFilterCondition);
    case ValidationCriteria.Text:
      return Object.values(TextFilterCondition);
  }
};
// #endregion
